var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHermetica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 441,
    viewBox: "0 0 441 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4834_17864)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 441,
    height: 441,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 0H0V441H441V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.854 129.23H256.242L265.585 94.3111C267.804 86.088 261.589 78 253.057 78H166.56C142.122 78 120.695 94.4269 114.364 118.035L79.7729 247.172C71.0672 279.544 95.5243 311.355 129.015 311.355H184.627L175.285 346.274C173.065 354.498 179.261 362.586 187.812 362.586H274.31C298.747 362.586 320.174 346.159 326.505 322.551L361.096 193.413C369.802 161.042 345.345 129.23 311.854 129.23ZM135.482 123.961C139.265 109.792 152.121 99.9283 166.772 99.9283L166.811 99.9669H241.301L217.694 187.989C214.316 200.594 202.869 209.377 189.82 209.377H112.607L135.462 123.961H135.482ZM129.208 289.427C110.04 289.427 96.0647 271.224 101.026 252.693C104.404 240.088 115.85 231.305 128.899 231.305H206.131L190.553 289.408H129.227L129.208 289.427ZM305.349 316.644C301.566 330.813 288.71 340.677 274.059 340.677H199.607L223.195 252.654C226.573 240.049 238.02 231.267 251.069 231.267L328.262 231.228L305.368 316.644H305.349ZM339.863 187.989C336.485 200.594 325.038 209.377 311.989 209.377H234.796L250.374 151.275H311.661C330.829 151.275 344.804 169.477 339.844 188.008L339.863 187.989Z",
    fill: "#0F1423"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4834_17864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 441,
    height: 441,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHermetica);
export default __webpack_public_path__ + "static/media/hermetica.f7438f0fc8e14c7b148db1f14248435d.svg";
export { ForwardRef as ReactComponent };